import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TokenListVisualNumberCell } from './token-list-visual-number.cell';
import { TokenListVisualNumberHeader } from './token-list-visual-number.header';

export const TokenListVisualNumberColumn: IdentifiedColumnDef<
  GatewayTokenModel,
  GatewayTokenModel['visualNumber']
> = {
  enableSorting: false,
  header: TokenListVisualNumberHeader,
  cell: TokenListVisualNumberCell,
};
